import { useMemo, useState } from 'react';

const PAGE_SIZE_OPTIONS = [10, 25, 50];

interface LinkedTablePagination {
  page: number;
  pageSize: number;
  pagination:
    | {
        page: number;
        pageSize: number;
        total: number;
        pageSizeOptions: number[];
        onPageChange: (page: number) => void;
        onPageSizeChange: (pageSize: number) => void;
      }
    | undefined;
}

/**
 * The total of a linked table is known before fetching, so up to the smallest
 * page size everything fits on one page without a pagination footer.
 */
export const useLinkedTablePagination = (
  total: number
): LinkedTablePagination => {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE_OPTIONS[0]);

  return useMemo(() => {
    if (total <= PAGE_SIZE_OPTIONS[0]) {
      return { page: 0, pageSize: Math.max(total, 1), pagination: undefined };
    }

    return {
      page,
      pageSize,
      pagination: {
        page,
        pageSize,
        total,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
        onPageChange: setPage,
        onPageSizeChange: setPageSize,
      },
    };
  }, [total, page, pageSize]);
};
